module.exports = __webpack_public_path__ + "static/media/strsn.aaddea0e.webp";